import Button from '@shared/components/Button/Button';
import { useTranslation } from 'react-i18next';

import { ReactComponent as Plus } from 'assets/icons/Plus.svg';
import SettingsCard from 'modules/SettingsModal/SettingsCard/SettingsCard';
import testingConstants from 'utils/testingConstants';

interface ApiKeysCreateRowProps {
  onCreate: () => void;
  disabled?: boolean;
}

const ApiKeysCreateRow = ({ onCreate, disabled = false }: ApiKeysCreateRowProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex flex-col items-center justify-between gap-4 md:flex-row">
      <div className="flex w-full flex-col space-y-1">
        <SettingsCard.Content.Title>
          {t('workspaces_settings.api_keys.create_section.title')}
        </SettingsCard.Content.Title>
        <SettingsCard.Content.Description>
          {t('workspaces_settings.api_keys.create_section.description')}
        </SettingsCard.Content.Description>
      </div>
      <Button
        variant="primary"
        size="sm"
        onClick={onCreate}
        disabled={disabled}
        iconRight={{ icon: Plus, className: 'stroke-current stroke-2' }}
        data-testid={testingConstants.apiKeysCreateButton}
        className="w-full md:w-fit"
      >
        {t('workspaces_settings.api_keys.create_button')}
      </Button>
    </div>
  );
};

export default ApiKeysCreateRow;
